export type Priority = "Critical" | "High" | "Medium" | "Low";
export type Status = "To Do" | "In Progress" | "In Review" | "Done";

export interface Task {
  id: string;
  title: string;
  assignee: string;
  priority: Priority;
  status: Status;
  startDate?: string;
  dueDate: string;
}

const assignees = ["AB", "CD", "EF", "GH", "IJ", "KL"];
const priorities: Priority[] = ["Critical", "High", "Medium", "Low"];
const statuses: Status[] = ["To Do", "In Progress", "In Review", "Done"];

/**
 * Generate a dataset of tasks for testing.
 * Includes overdue tasks, tasks due today, and some with missing start dates.
 */
export function generateTasks(count: number = 500): Task[] {
  const tasks: Task[] = [];
  for (let i = 0; i < count; i++) {
    // Random due date: between -10 days (overdue) and +30 days (future)
    const due = randomDate(-10, 30);

    // Random start date: sometimes missing
    const start =
      Math.random() > 0.3
        ? randomDate(-15, 25) // start before due
        : undefined;

    tasks.push({
      id: `task-${i}`,
      title: `Task ${i + 1}`,
      assignee: assignees[Math.floor(Math.random() * assignees.length)],
      priority: priorities[Math.floor(Math.random() * priorities.length)],
      status: statuses[Math.floor(Math.random() * statuses.length)],
      startDate: start,
      dueDate: due,
    });
  }
  return tasks;
}

/**
 * Generate a random date offset from today.
 * @param minOffset minimum days offset from today
 * @param maxOffset maximum days offset from today
 */
function randomDate(minOffset: number, maxOffset: number): string {
  const today = new Date();
  const offset =
    Math.floor(Math.random() * (maxOffset - minOffset + 1)) + minOffset;
  const date = new Date(today);
  date.setDate(today.getDate() + offset);
  return date.toISOString().split("T")[0];
}

